import React, { useRef } from 'react';
import reactDom from 'react-dom';

import { message } from 'antd';
import { observer } from 'mobx-react';
import { NextRouter } from 'next/router';

import { IAssetPasswordReq } from '@api/customer.type';
import { THEME, USER_PATHS } from '@constants/index';
import { useIsomorphicLayoutEffect } from '@lib/hooks';
import { store } from '@store/index';
import { IKycStatus } from '@type/user';
import { helper, I18n } from '@utils/index';
import { openAirdropVerify } from '@widget/wallet/deposit/AssetWidthDrawAddressModal/AirdropVerifyModal';

import { openNotKyc1 } from '../NotKyc1';
import { openSetPassword } from '../SetPassword';
import { IResolve } from './type';
import { useCommon } from './useCommon';
import { useSetAssetPassword } from './useSetAssetPassword';
import { useSetPwd } from './useSetPwd';

interface IMainProps {
  resolve: IResolve;
  el: HTMLElement;
  router: NextRouter;
  theme?: Theme
}

const Main: React.FC<IMainProps> = observer((props) => {
  const { router, resolve, theme = THEME.HIGHLIGHT } = props;
  // 是否设置了资金密码
  const { isExistAssetPassword = false } = store.userStore.userInfo;

  /** 设置资金密码数据挂载 */
  const dataRef = useRef<Partial<IAssetPasswordReq>>({});

  const { verifyAssetPwd } = useCommon({ dataRef });

  const setPwdCb = () => {
    message.success(I18n.t('success'));
    resolve({ status: 'ok' })
  }
  const { setAssetPassword } = useSetAssetPassword({ dataRef, store, cb: setPwdCb })

  const { setPwd } = useSetPwd({ dataRef, theme, cb: setAssetPassword, firstModalTitle: I18n.t('4sULLgiV') })

  /** 输入密码 */
  const inputPwd = async () => {
    /** 验证资金密码 */
    const pwdRes = await openSetPassword({
      title: I18n.t('b41RSiHq'),
      theme,
      onComplete: (pwd) => verifyAssetPwd(helper.md5(pwd)),
      onForgetPwd: (close) => {
        close();
        dataRef.current.type = 2;
        secondVerify();
      }
    })
    if (pwdRes === 'cancel') {
      resolve({ status: 'cencel' })
      return
    }
    dataRef.current.type = 1;
    /** 资金密码验证成功后 设置资金密码 */
    setPwd()
  }
  /** 二次验证 修改/设置密码 */
  const secondVerify = async () => {
    const { state, data } = await openAirdropVerify({ theme });
    if (state === 'ok') {
      dataRef.current.tokenId = data;
      setPwd();
    }
  }
  /** 定义工作流 */
  const flow = async () => {
    // KYC1 是否认证通过
    const { certifiedStatus } = store.tradeStore.kycInfo;
    // KYC1 审核中时只提示，不跳转, 前置判断
    if (IKycStatus.L1_AUDIIING === certifiedStatus) {
      message.info(I18n.t('KPXAWSMw'));
      return;
    }
    if (![IKycStatus.L1_SUCCESS, IKycStatus.L2_AUDIIING, IKycStatus.L2_REJECT, IKycStatus.L2_SUCCESS].includes(certifiedStatus)) {
      const notKycRes = await openNotKyc1({ theme });
      if (notKycRes === 'ok') {
        router.push(USER_PATHS.KYC)
      }
      return
    }
    // 是否设置了资金密码
    if (isExistAssetPassword) {
      inputPwd();
      return
    }
    dataRef.current.type = 0;
    secondVerify();
  }
  useIsomorphicLayoutEffect(() => {
    flow();
  }, []);
  return null;
})

export const openSetAssPwd = (props: Omit<IMainProps, 'resolve'>): Promise<any> => {
  const el = document.createElement('div');
  return new Promise((resolve) => {
    reactDom.render(<Main {...props} resolve={resolve} />, el);
  })
}
